import styled from 'styled-components';

export const MessageWrapper = styled.div`
    color: #842029;
    background-color: #f8d7da;
    border: 1px solid #f5c2c7;
    border-radius: 4px;
    padding: 1rem;
    font-size: 0.95rem;
    line-height: 1.4;
    width: 50%;
`;

export const Snippet = styled.div`
    background-color: #f1f1f1;
    padding: 0.5rem;
    border-radius: 4px;
    overflow-x: auto;
    margin-top: 0.5rem;
`;
